module.exports = __webpack_public_path__ + "media/src/website/images/locations/rimsting/rimsting_small_01-092fb65b7eb12f8e502d9d205b16c177.jpg";